'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function CityComponent($http, AppConstants) {
	'ngInject';

	var service = {
		fetchCities: fetchCities,
		searchCities: searchCities,
		fetchCity: fetchCity,
		getCities: getCities,
		getCity: getCity,
		getPaginationInfo: getPaginationInfo,
		getResultSearchCities: getResultSearchCities,
		clearResultSearchCities: clearResultSearchCities,
		createCity: createCity,
		updateCity: updateCity,
		deleteCity: deleteCity
	};

	var cities = [];
	var city = {};
	var resultSearchCities = [];
	// Information for pagination, current_page, total(count of items), and per_page(items on page)
	var paginationInfo = {};

	return service;

	function searchCities(value, isActive) {
		if (value.length < 1) {
			clearResultSearchCities();
		}

		var params = {
			'params': {
				'query': value,
				'page': 1,
				'per_page': AppConstants.perPage,
				'with': 'stations,country'
			}
		};

		if (isActive) {
			params.params.is_active = 1;
		}

		return $http.get(AppConstants.apiUrl + '/cities', params).then(setResultSearchCities)['catch'](failedRequest);
	}

	function fetchCities() {
		var page = arguments.length <= 0 || arguments[0] === undefined ? 1 : arguments[0];
		var sort = arguments.length <= 1 || arguments[1] === undefined ? '-id' : arguments[1];

		return $http.get(AppConstants.apiUrl + '/cities', {
			'params': {
				page: page,
				sort: sort,
				'per_page': AppConstants.perPage
			}
		}).then(setCities)['catch'](failedRequest);
	}

	/**
  *
  * @param {Integer} id {ID of city}
  * @param {String} withTranslate, can be  'translations'(with all translations)
  * or 'translation'(with translation for current language)
  * @returns {*}
  */
	function fetchCity(id) {
		var relations = arguments.length <= 1 || arguments[1] === undefined ? 'translations,country,stations' : arguments[1];

		return $http.get(AppConstants.apiUrl + '/cities/' + id, {
			'params': {
				'with': relations
			}
		}).then(setCity)['catch'](failedRequest);
	}

	function setCities(response) {
		paginationInfo.page_size = AppConstants.perPage;
		paginationInfo.page = response.data.current_page;
		paginationInfo.total = response.data.total;
		cities = response.data.data;

		return cities;
	}

	function setCity(response) {
		city = response.data.data;

		return city;
	}

	function setResultSearchCities(response) {
		resultSearchCities = response.data.data;

		return resultSearchCities;
	}

	function getCities() {
		return cities;
	}

	function getCity() {
		return city;
	}

	function getPaginationInfo() {
		return paginationInfo;
	}

	function getResultSearchCities() {
		return resultSearchCities;
	}

	function clearResultSearchCities() {
		resultSearchCities = [];

		return resultSearchCities;
	}

	function createCity(params) {
		return $http.post(AppConstants.apiUrl + '/cities', params).then(successRequest)['catch'](failedRequest);
	}

	function updateCity(id, params) {
		return $http.put(AppConstants.apiUrl + '/cities/' + id, params).then(successRequest)['catch'](failedRequest);
	}

	function deleteCity(id) {
		return $http['delete'](AppConstants.apiUrl + '/cities/' + id).then(successRequest)['catch'](failedRequest);
	}

	function successRequest(response) {
		return response;
	}

	function failedRequest(requestError) {
		console.log(requestError);

		return requestError;
	}
}
exports['default'] = CityComponent;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/city/city.service.js
 **/